import React, { useState } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import EditorInfoIcon from '@atlaskit/icon/glyph/editor/info';
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import Popup from '@atlaskit/popup';
// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

export const LimitReachedPopup = () => {
	const [isDisabledPopupOpen, setIsDisabledPopupOpen] = useState<boolean>(false);
	const { formatMessage } = useIntl();

	return (
		<Popup
			isOpen={isDisabledPopupOpen}
			onClose={() => {
				setIsDisabledPopupOpen(false);
			}}
			placement="bottom-end"
			content={() => (
				<PopupWrapper>{formatMessage(messages.limitReachedPopupContent)}</PopupWrapper>
			)}
			trigger={(triggerProps) => (
				<Button
					{...triggerProps}
					onClick={(_, analyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'externalResourceLimitReachedInfo');
						setIsDisabledPopupOpen(!isDisabledPopupOpen);
					}}
					iconBefore={
						isDisabledPopupOpen ? (
							<EditorInfoIcon label={messages.editorInfoIconLabel.defaultMessage} />
						) : (
							<EditorPanelIcon label={messages.editorPanelIconLabel.defaultMessage} />
						)
					}
					appearance="subtle-link"
				/>
			)}
		/>
	);
};

export default LimitReachedPopup;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PopupWrapper = styled.div({
	padding: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${34 * gridSize}px`,
});
